import {Link as LocalizedLink} from '@components/@nav';
import {getEnv} from '@config/getEnv';
import classNames from 'classnames';
import NextLink, {LinkProps} from 'next/link';
import {
    AnchorHTMLAttributes,
    ButtonHTMLAttributes,
    DetailedHTMLProps,
    FC,
    HTMLProps,
} from 'react';
import styles from './MeinLink.module.css';

type IProps = (
    | ((
          | DetailedHTMLProps<
                AnchorHTMLAttributes<HTMLAnchorElement>,
                HTMLAnchorElement
            >
          | LinkProps
      ) & {
          asButton?: boolean;
      })
    | (DetailedHTMLProps<
          ButtonHTMLAttributes<HTMLButtonElement>,
          HTMLButtonElement
      > & {asButton: true})
) & {dontLocalize?: boolean; className?: string; external?: boolean};

export const MeinLink: FC<IProps> = ({
    external,
    dontLocalize,
    className,
    asButton,
    ...rest
}) => {
    if (asButton) {
        return (
            <button
                {...(rest as DetailedHTMLProps<
                    ButtonHTMLAttributes<HTMLButtonElement>,
                    HTMLButtonElement
                >)}
                className={classNames(styles.link, className)}
            />
        );
    }

    if (external) {
        return (
            <a
                target="_blank"
                rel="noopener noreferrer"
                {...(rest as HTMLProps<HTMLAnchorElement>)}
                className={classNames(styles.link, className)}
            />
        );
    }

    const overriddenLinkProps: Partial<LinkProps> = {};

    if (getEnv('NEXT_PUBLIC_E2E')) {
        overriddenLinkProps.prefetch = false;
    }

    if (dontLocalize) {
        return (
            <NextLink
                prefetch={false}
                {...(rest as LinkProps)}
                className={classNames(styles.link, className)}
                {...overriddenLinkProps}
            />
        );
    }

    return (
        <LocalizedLink
            {...(rest as LinkProps)}
            className={classNames(styles.link, className)}
            {...overriddenLinkProps}
        />
    );
};
